import React from 'react';
import moment from 'moment'
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined'
import '../../assets/scss/tables.scss'

const UserAssetsDetails = ({ assets = [] }) => {
    const ValidAssets = assets?.filter((asset) => asset?.item && asset?.serial_no)
    return (
        <div className="wh-panel">
            <h6 className="wh-section-title" style={{ marginTop: 0 }}>
                <Inventory2OutlinedIcon />Assets Issued To You
            </h6>
            {ValidAssets && ValidAssets?.length > 0 ? <div className="table-responsive wh-table-shell">
                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col">S.No</th>
                            <th scope="col">Asset Name</th>
                            <th scope="col">Serial Number</th>
                            <th scope="col">Issued Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            ValidAssets && ValidAssets?.map((data, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td><span className="wh-pill">{data.item}</span></td>
                                    <td>{data.serial_no}</td>
                                    <td>{moment(new Date(data.issued_date)).format("DD-MM-YYYY") == 'Invalid date' ? data.issued_date : moment(new Date(data.issued_date)).format("DD-MM-YYYY")}</td>
                                </tr>)
                            )
                        }
                    </tbody>
                </table>
            </div> : <p className='wh-section-empty'>No assets are issued to you at the moment.</p>}
        </div>
    )
}

export default UserAssetsDetails